export default __webpack_public_path__ + "static/media/polluted-soil.999f850e.png";